import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import filesize from 'filesize/lib/filesize.es6.js';
import { AssetsService } from '../../../assets-library/services/assets.service';
import last from 'lodash/last';
import { FileFormatService } from '../../../assets-library/services/fileformat.service';
import {RolesService} from "../../../../core/services/roles/roles.service";


@Component({
  selector: 'select-media',
  templateUrl: './select-media.component.html',
  styleUrls: ['./select-media.component.scss'],
})
export class SelectMediaComponent implements OnChanges {
  searchValue: String = '';
  assetsStatus: String = 'loading';
  canSelect: Boolean = true;
  canEdit: Boolean = false;
  isModalOpen: Boolean = false;
  selectedItem: any = null;
  selectedItemCash: any = null;
  showPreview: Boolean = false;
  showUploadModal: Boolean = false;
  imagesLength: Number = 0;
  searchForValue: string;
  mediaUploaded: boolean = false;
  showUpload: boolean = false;

  @Input() imageOnly: Boolean;
  @Input() mediaFilter: "image" | "document" | "video" = undefined;
  @Input() image: String;
  @Output() setImageRef = new EventEmitter();

  constructor(private assetsService: AssetsService, private fileFormatService: FileFormatService,
              public rolesService: RolesService,) {}

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.image.currentValue.length) {
      this.removeMedia();
    }

    if (this.image && changes.image.previousValue !== this.image) {
      this.mediaUploaded = false;
      // TODO: GET ASSET DATA BY ASSET ID FUNCTIONALITY
      this.assetsService.getAssetDataById(this.image, (data) => {
        if (data) {
          const { reference, name, contentType, size, resolution, uploadedDate, mediaURL } = data;
          const newName = this.cutFileName(name);

          this.selectedItem = {
            id: reference,
            name: newName.name,
            format: contentType,
            size,
            resolution,
            uploaded: uploadedDate,
            src: mediaURL,
            type: newName.type,
          };
        }
        this.mediaUploaded = true;
      });
    } else {
      this.mediaUploaded = true;
    }
  }

  ngOnInit(){
    this.showUpload = this.rolesService.canEditAssets();
  }

  cutFileName(fileName) {
    const nameArr = fileName.split('.');
    const type = last(nameArr);
    nameArr.pop();
    const name = nameArr.join('.');
    return { type, name };
  }

  checkAssets(data) {
    this.assetsStatus = data;
  }

  setIsModalOpen(status) {
    this.assetsStatus = 'loading';
    this.isModalOpen = status;
    this.searchValue = '';
    this.clearAssetCash();
  }

  selectAssetHandler(e) {
    if (this.selectedItemCash && e && this.selectedItemCash.id === e.id) {
      this.clearAssetCash();
    } else {
      this.selectedItemCash = e;
    }
  }

  clearAssetCash() {
    this.selectedItemCash = null;
  }

  checkIsAssetSelected() {
    return this.selectedItemCash ? true : false;
  }

  removeMedia() {
    this.selectedItem = null;
    this.clearAssetCash();
    this.setImageRef.emit('');
  }

  addAsset() {
    if (this.selectedItemCash) {
      this.selectedItem = this.selectedItemCash;
      this.setImageRef.emit(this.selectedItem.id);
    }
    this.setIsModalOpen(false);
  }

  setFilesize(size: number) {
    return filesize(size);
  }

  setShowPreview(status) {
    if (this.checkIsSelectedItemImage()) {
      this.showPreview = status;
    }
  }

  uploadNewAsset(e: Event) {
    e.stopPropagation();
    this.showUploadModal = true;
    this.isModalOpen = false;
  }

  cancelUpload() {
    this.showUploadModal = false;
    this.isModalOpen = true;
  }

  finishUpload() {
    this.assetsStatus = 'updated';
  }

  getImagesLength(length) {
    this.imagesLength = length;
  }

  checkIsSelectedItemImage() {
    return (
      this.selectedItem &&
      this.selectedItem.format &&
      this.selectedItem.format.split('/')[0] === 'image'
    );
  }

  setSelectedItemBG(src) {
    if (this.checkIsSelectedItemImage()) {
      return src;
    }

    const item = this.fileFormatService.getType(this.selectedItem.format);
    this.selectedItem.type = item.type ? item.type : '';
    return item.type ? '../../assets/svg/empty.svg' : '../../assets/svg/invalid.svg';
  }

  searchForChange(event: any) {
    this.searchForValue = event.value;
  }

  imageLoaded() {

  }
}
